import { ReactNode, JSX } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

const MAX_RETRIES = 2;
const HTTP_STATUS_TO_NOT_RETRY = [400, 401, 403, 404];

export function QueryProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (failureCount >= MAX_RETRIES) {
            return false;
          }

          return !(
            isAxiosError(error) &&
            HTTP_STATUS_TO_NOT_RETRY.includes(error.response?.status ?? 0)
          );
        },
        retryDelay: 1000,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
